
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 23 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.598 1.854c.599-1.843 3.205-1.843 3.804 0l1.129 3.474a2 2 0 001.902 1.382h3.653c1.938 0 2.743 2.48 1.176 3.618l-2.956 2.147a2 2 0 00-.726 2.236l1.129 3.475c.598 1.842-1.51 3.375-3.078 2.236l-2.955-2.147a2 2 0 00-2.352 0L7.37 20.422c-1.567 1.139-3.676-.394-3.078-2.236l1.13-3.474a2 2 0 00-.727-2.237l-2.956-2.147C.171 9.19.977 6.71 2.914 6.71h3.653a2 2 0 001.902-1.382z","fill":"#e0e0e0"}})])
          )
        }
      }
    